/**
 * Enum for storage keys used in the application
 */
export enum StorageKeys {
    /**
     * Key for user session
     */
    SESSION = 'session'
}